import { createReducer, on, Action } from '@ngrx/store';

import * as PartCostsNotSavedChangesActions from './part-costs-not-saved-changes.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export const PART_COSTS_NOT_SAVED_CHANGES_FEATURE_KEY = 'partCostsNotSavedChangesActions';

export interface PartCostsNotSavedChangesEntity {
  id: string;
  franchiseMSP: number;
  isValid: boolean;
}

export interface PartCostNotSavedChangesState {
  readonly [PART_COSTS_NOT_SAVED_CHANGES_FEATURE_KEY]: EntityState<PartCostsNotSavedChangesEntity>;
}

export const partCostsNotSavedChangesAdapter: EntityAdapter<PartCostsNotSavedChangesEntity> =
  createEntityAdapter<PartCostsNotSavedChangesEntity>();

export const initialPartCostsNotSavedChangesState: EntityState<PartCostsNotSavedChangesEntity> =
  partCostsNotSavedChangesAdapter.getInitialState();

const reducer = createReducer(
  initialPartCostsNotSavedChangesState,
  on(PartCostsNotSavedChangesActions.updateNotSavedFranchiseMSP, (state, { partPricingId, franchiseMSP, isValid }) => {
    const payload = {
      id: partPricingId,
      franchiseMSP,
      isValid,
    };
    return partCostsNotSavedChangesAdapter.upsertOne(payload, state);
  }),
  on(PartCostsNotSavedChangesActions.removeAllNotSavedFranchiseMSP, state =>
    partCostsNotSavedChangesAdapter.removeAll(state)
  )
);

export function partCostsNotSavedChangesReducer(
  state: EntityState<PartCostsNotSavedChangesEntity> | undefined,
  action: Action
): EntityState<PartCostsNotSavedChangesEntity> {
  return reducer(state, action);
}
